import React, {useEffect, useState} from "react";
import {Box, Button, Dialog, DialogContent, IconButton, Stack, Typography} from "@mui/material";
import questionType from "../assets/data/typeMap";
import {QuestionSwitch} from "./Questions/QuestionSwitch";
import {firestore} from "../firebase/clientApp";
import {useParams} from "react-router-dom";
import {Close} from "@mui/icons-material";
import pleshDark from "../theme/pleshDark";
import { useTranslation } from 'react-i18next';
import useLanguageStore from "../store/languageStore";
import { getTranslatedText } from "../functions/getTranslatedText";


export const PinnedQuestions = ({questions}) => {
  const { t } = useTranslation('components');
  const [selected, setSelected] = useState('')
  const {eventOwnerId, id} = useParams()

  const [elementPlaying, setElementPlaying] = useState({})
  const { currentLanguage, defaultLanguage } = useLanguageStore();

  useEffect(() => {
    selected !== '' ? getElementPlaying() : setElementPlaying({})
  }, [selected]);

  function getElementPlaying() {
    firestore.collection(`users/${eventOwnerId}/events/${id}/queue`).doc(selected).onSnapshot(s => {
      setElementPlaying({...s.data(), id: s.id})
      return s.data()
    })
  }

  return (
    <Box mt={3}>
      {selected !== '' &&
        <Dialog open={selected !== ''} onClose={() => setSelected('')} maxWidth={'md'}
                fullWidth={true}
                fullScreen={elementPlaying.tipo === 'color'}
        >
          <DialogContent id={'a' + selected} /*id={'pinnedQuestionDialogBg'}*/>
            <Box sx={{textAlign: 'right'}}>
              <IconButton onClick={() => setSelected('')}
                          sx={{
                            color: elementPlaying.tipo === 'color' ? pleshDark.palette.getContrastText(elementPlaying.color) : ''
                          }}
              >
                <Close/>
              </IconButton>
            </Box>
            <Typography textAlign='center' variant='h5' whiteSpace='pre-line'
                        sx={{color: elementPlaying.tipo === 'color' ? pleshDark.palette.getContrastText(elementPlaying.color) : ''}}
            >
              {getTranslatedText(elementPlaying.domanda, elementPlaying.domandaTranslations, currentLanguage, defaultLanguage)}
            </Typography>
            {elementPlaying.domandaDescription && <Typography textAlign='center' variant='body1' fontWeight='lighter' whiteSpace='pre-line'
                                                              sx={{color: elementPlaying.tipo === 'color' ? pleshDark.palette.getContrastText(elementPlaying.color) : ''}}
            >
              {getTranslatedText(elementPlaying.domandaDescription, elementPlaying.domandaDescriptionTranslations, currentLanguage, defaultLanguage)}
            </Typography>}
            <QuestionSwitch elementPlaying={elementPlaying}/>
          </DialogContent>
        </Dialog>}
      <Stack spacing={2}>
        {
          questions.docs?.length > 0 ?
            questions.docs?.sort((a, b) => a.data().pinPosition - b.data().pinPosition).map((q, i) => {
                return <Button key={i} variant='home-question' startIcon={questionType[q.data().tipo]?.icon}
                               sx={{
                                 background: q.data().tipo === 'color' ? q.data().color : '',
                                 color: q.data().tipo === 'color' ? pleshDark.palette.getContrastText(q.data().color) : '',
                                 whiteSpace: 'pre-line',
                               }}
                               onClick={() => setSelected(q.id)}>
                  {getTranslatedText(q.data().domanda, q.data().domandaTranslations, currentLanguage, defaultLanguage)}
                </Button>
              }
            )
            :
              <Typography textAlign={'left'} pl={2} fontSize={'1.1rem'} whiteSpace='pre-line' fontWeight={'normal'}>
                {t('pinnedQuestions.waitHere')} <br/>
                {t('pinnedQuestions.nextInteractionSoon')}
              </Typography>
        }
      </Stack>
    </Box>
  )
}